"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritQuandCorporationTrads = void 0;
exports.ESubDejaSouscritQuandCorporationTrads = {
    less_than_a_year_ago: "Il y a moins d'un an",
    more_than_a_year_ago: "Il y a plus d'un an",
};
